var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.72 5.14645L2.42669 23.9998C2.19385 24.403 2.07065 24.8602 2.06935 25.3258C2.06804 25.7914 2.18868 26.2493 2.41926 26.6538C2.64984 27.0583 2.98233 27.3954 3.38364 27.6316C3.78495 27.8677 4.24109 27.9947 4.70669 27.9998H27.2934C27.759 27.9947 28.2151 27.8677 28.6164 27.6316C29.0177 27.3954 29.3502 27.0583 29.5808 26.6538C29.8114 26.2493 29.932 25.7914 29.9307 25.3258C29.9294 24.8602 29.8062 24.403 29.5734 23.9998L18.28 5.14645C18.0423 4.75459 17.7077 4.43061 17.3083 4.20576C16.9089 3.98092 16.4583 3.86279 16 3.86279C15.5417 3.86279 15.0911 3.98092 14.6918 4.20576C14.2924 4.43061 13.9577 4.75459 13.72 5.14645V5.14645Z",
    stroke: "#C43333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V17.3333",
    stroke: "#C43333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6665H16.0133",
    stroke: "#C43333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert_red.fd87276b884d926fe7aceaeea0ccc44c.svg";
export { ForwardRef as ReactComponent };